import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface CrmPrintMenuOption {
  id: string;
  label: string;
}

@Component({
  selector: 'app-crm-print-menu',
  template: `
    <div class="crm-print-menu">
      <as-button type="secondary" [minimal]="true" size="small" (click)="toggleMenu($event)">
        <as-icon type="print"></as-icon>
        {{ buttonLabel }}
        <i class="fa" [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </as-button>

      <div class="crm-print-menu-panel" *ngIf="isOpen">
        <button
          type="button"
          class="crm-print-menu-item"
          *ngFor="let option of options; trackBy: trackByOptionId"
          (click)="selectOption(option.id)">
          {{ option.label }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    .crm-print-menu {
      position: relative;
    }

    .crm-print-menu-panel {
      position: absolute;
      top: calc(100% + 8px);
      right: 0;
      min-width: 220px;
      padding: 8px;
      border: 1px solid #d1d5db;
      border-radius: 12px;
      background: #ffffff;
      box-shadow: 0 18px 36px rgba(15, 23, 42, 0.16);
      z-index: 1200;
    }

    .crm-print-menu-item {
      display: block;
      width: 100%;
      border: 0;
      border-radius: 8px;
      background: transparent;
      color: #111827;
      cursor: pointer;
      font-size: 14px;
      line-height: 1.4;
      padding: 10px 12px;
      text-align: left;
      transition: background 0.2s ease, color 0.2s ease;
    }

    .crm-print-menu-item:hover,
    .crm-print-menu-item:focus {
      outline: none;
      background: #eff6ff;
      color: #0f4c81;
    }
  `]
})
export class CrmPrintMenuComponent {
  @Input() buttonLabel = 'Print';
  @Input() options: CrmPrintMenuOption[] = [];
  @Output() optionSelected = new EventEmitter<string>();

  isOpen = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {
  }

  toggleMenu(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  selectOption(optionId: string): void {
    this.isOpen = false;
    this.optionSelected.emit(optionId);
  }

  trackByOptionId(index: number, option: CrmPrintMenuOption): string {
    return option.id;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node | null;

    if (target && !this.elementRef.nativeElement.contains(target)) {
      this.isOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen = false;
  }
}

